import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { getCommunity } from "../../config/communityConfig";

import CommunityHeader from "../../components/community/CommunityHeader";
import CommunitySidebar from "../../components/community/CommunitySidebar";
import TrendingSidebar from "../../components/community/TrendingSidebar";
import ComposeCard from "../../components/community/ComposeCard";
import ThreadList from "../../components/community/ThreadList";
import ComposePost from "../../components/community/ComposePost";
import useCommunityAccess from "../../hooks/useCommunityAccess";
import LockedCommunity from "../../components/community/LockedCommunity";
import useCommunityFeed from "../../hooks/useCommunityFeed";
import { useAuth } from "../../context/AuthContext";
import CommentDrawer from "../../components/community/CommentDrawer";

import { getCommunityProducts } from "../../api/communityApi";


export default function CommunityThreadsPage() {

    const navigate = useNavigate();

    const { category } = useParams();

    const community = getCommunity(category);

    const [products, setProducts] = useState([]);

    const [showCompose, setShowCompose] = useState(false);

    const { hasAccess } = useCommunityAccess();

    const access = hasAccess(category);

    const [selectedPost, setSelectedPost] = useState(null);

    const { user } = useAuth();

    const {
        posts,
        loading,
        hasMore,
        loadMore,

        toggleLike,

        addPost,

        refresh,

        comments,
        commentsLoading,

        loadComments,
        addComment,
        editComment,
        removeComment

    } = useCommunityFeed(category);

    useEffect(() => {

        loadProducts();

    }, [category]);

    async function loadProducts() {

        try {

            const response = await getCommunityProducts(category);

            setProducts(response);

        }

        catch (e) {

            console.error(e);

        }

    }

    async function handleComment(post) {

        console.log("Opening comments:", post);

        setSelectedPost(post);

        await loadComments(post.id);

    }

    function handleShare(post) {

        console.log(post);

    }

    function handleBookmark(post) {

        console.log(post);

    }

    if (!community) {

        return (

            <div className="min-h-screen flex items-center justify-center">

                Community Not Found

            </div>

        );

    }

    if (!access) {

        return (

            <LockedCommunity

                community={community}

                featuredProducts={products}

                onShopNow={() =>

                    navigate(

                        `/shop?community=${community.shopCollection}`

                    )

                }

                onProductClick={(product) =>

                    navigate(

                        `/product/${product.id}`

                    )

                }

            />

        );

    }

    return (

        <div
            className="
                min-h-screen
                bg-gradient-to-br
                from-slate-50
                via-white
                to-blue-50
            "
        >

            <div className="max-w-7xl mx-auto px-6 py-8">

                <CommunityHeader

                    community={community}

                    members={community.stats.members}

                    posts={community.stats.posts}

                    online={community.stats.online}

                    onShop={() =>

                        navigate(

                            `/shop?community=${community.shopCollection}`

                        )

                    }

                />

                <div
                    className="
                        mt-10
                        grid
                        grid-cols-12
                        gap-8
                    "
                >

                    {/* LEFT SIDEBAR */}

                    <div className="hidden xl:block xl:col-span-3">

                        <CommunitySidebar

                            community={community}

                            stats={community.stats}

                            products={products}

                            onOpenProduct={(product) =>

                                navigate(

                                    `/product/${product.id}`

                                )

                            }

                            onOpenRules={() => { }}

                        />

                    </div>

                    {/* FEED */}

                    <div className="col-span-12 xl:col-span-6">

                        <ComposeCard

                            community={community}

                            hasAccess={access}

                            user={user}

                            onCompose={() =>

                                setShowCompose(true)

                            }

                            onUnlock={() =>

                                navigate(

                                    `/shop?community=${community.shopCollection}`

                                )

                            }

                        />

                        <div className="mt-8">

                            <ThreadList

                                posts={posts}

                                loading={loading}

                                hasMore={hasMore}

                                loadMore={loadMore}

                                onLike={toggleLike}

                                onComment={handleComment}

                                onShare={handleShare}

                                onBookmark={handleBookmark}

                            />

                        </div>

                    </div>

                    {/* RIGHT SIDEBAR */}

                    <div className="hidden xl:block xl:col-span-3">

                        <TrendingSidebar

                            trending={[]}

                            creators={[]}

                            events={[]}

                            leaderboard={[]}

                            onThreadClick={() => { }}

                            onCreatorClick={() => { }}

                            onEventClick={() => { }}

                            onLeaderboardClick={() => { }}

                        />

                    </div>

                </div>

            </div>

            {/* Compose Post Modal */}

            {

                showCompose && (

                    <ComposePost

                        category={category}

                        onClose={() =>

                            setShowCompose(false)

                        }

                        onSubmit={async (formData) => {

                            try {

                                await addPost(formData);

                                setShowCompose(false);

                            }

                            catch (e) {

                                console.error(e);

                            }

                        }}
                    />

                )

            }

            {selectedPost && (
                <CommentDrawer
                    post={selectedPost}
                    comments={comments[selectedPost.id] || []}
                    loading={commentsLoading[selectedPost.id] || false}
                    onClose={() => setSelectedPost(null)}
                    onSend={(content) =>
                        addComment(selectedPost.id, content)
                    }
                    onDelete={(commentId) =>
                        removeComment(selectedPost.id, commentId)
                    }
                    onEdit={(commentId, content) =>
                        editComment(
                            selectedPost.id,
                            commentId,
                            content
                        )
                    }
                />
            )}

        </div>

    );

}